import script from "./ModeloVehiculoTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModeloVehiculoTable.vue?vue&type=script&setup=true&lang=ts"

import "./ModeloVehiculoTable.vue?vue&type=style&index=0&id=2a544c4d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a544c4d"]])

export default __exports__